import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FilterField } from './filter';

@Component({
  template: '',
  standalone: false,
})
export class FilterFieldComponent<T extends FilterField<any>> {
  @Input() filterField: T;
  @Output() filterApplied: EventEmitter<T> = new EventEmitter<T>();

  applyFilter(value: any): void {
    this.filterField.changeValue(value);
    this.filterApplied.emit(this.filterField);
  }
}
